/* Copyright (c) 2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Box, Container, FlexContainer, Row, theme } from "@nordcloud/gnui";
import { Logo, User } from "./components";

const StyledLink = styled(Link)`
  display: flex;
  height: 100%;
  align-items: center;
  padding-left: ${theme.spacing.spacing02};
`;

export function Header() {
  return (
    <Box padding={`0.25rem 0`} mb={0} css={{ borderRadius: 0 }}>
      <Container fluid>
        <Row justify="space-between">
          <span>
            <StyledLink to="/">
              <Logo />
            </StyledLink>
          </span>
          <FlexContainer>
            <User />
          </FlexContainer>
        </Row>
      </Container>
    </Box>
  );
}
